export type ApprovalStatusKey = "approved" | "sent" | "pending";
export type ApprovalBucket = "pending" | "approved";

export type PayrollPeriod = {
  year: string;
  month: string;
};

export type ApprovalLifecycleRecord = {
  approved?: boolean | null;
  sent_for_approval?: boolean | null;
  status?: string | null;
};

type ApprovalApiItem = ApprovalLifecycleRecord & {
  emptID?: string | null;
  employee_id?: string | null;
  data?: ApprovalLifecycleRecord & {
    emptID?: string | null;
    employee_id?: string | null;
  };
};

type SendForApprovalResult = {
  employee_id?: string | null;
  success?: boolean | null;
};

type SendForApprovalResponse = {
  data?: {
    results?: SendForApprovalResult[];
  };
};

const normaliseStatus = (status?: string | null) =>
  (status || "").trim().toLowerCase().replace(/[\s-]+/g, "_");

export const getPreviousPayrollPeriod = (baseDate: Date = new Date()): PayrollPeriod => {
  const date = new Date(baseDate);
  date.setDate(1);
  date.setMonth(date.getMonth() - 1);

  return {
    year: String(date.getFullYear()),
    month: String(date.getMonth() + 1).padStart(2, "0"),
  };
};

export const isAwaitingApproval = (record: ApprovalLifecycleRecord) => {
  const status = normaliseStatus(record.status);
  return (
    record.sent_for_approval === true ||
    status === "sent_for_approval" ||
    status === "pending_approval" ||
    status === "awaiting_approval"
  );
};

export const approvalBucketFor = (record: ApprovalLifecycleRecord): ApprovalBucket =>
  record.approved ? "approved" : "pending";

export const statusAfterSendForApproval = (current?: ApprovalStatusKey): ApprovalStatusKey =>
  current === "approved" ? "approved" : "sent";

export const buildApprovalStatusMap = (items: ApprovalApiItem[] = []) => {
  const map: Record<string, ApprovalStatusKey> = {};

  items.forEach((item) => {
    const record = item?.data || item;
    const id = record?.emptID || record?.employee_id;
    if (!id) return;
    map[id] = approvalBucketFor(record) === "approved" ? "approved" : "sent";
  });

  return map;
};

export const successfulSendForApprovalIds = (
  response: SendForApprovalResponse,
  requestedIds: string[]
) => {
  const results = response?.data?.results;
  if (!Array.isArray(results)) return requestedIds;

  return results
    .filter((item) => item?.success !== false && item?.employee_id)
    .map((item) => String(item.employee_id));
};
